import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import moment from 'moment';


const mapLineToApiLineDto = (values: IEditDataLineBillingForm , dataLineID:number): IPostEditDataLineBilling | {} => {
  let dataMapping: IPostEditDataLineBilling ;
  

    dataMapping = {
      dbDate: values.dbDate ? `${moment(values.dbDate.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      billMonth: +values.billMonth,
      billYear: +values.billYear,
      dbDateFrom: values.dbDateFrom ? `${moment(values.dbDateFrom.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      dbDateTo: values.dbDateTo ? `${moment(values.dbDateTo.toString()).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null,
      cost: +values.cost,
      lEnd: +values.lEnd,
      comLineID: dataLineID,
      deleted: false,
      description: "",
    }
  
  return dataMapping;
}


export const editDataLineBilling = ( {data, dataLineID, billingId} : {data: IEditDataLineBillingForm, dataLineID:number, billingId:number }): Promise<string> => {
  const line = mapLineToApiLineDto(data,dataLineID);
  return axiosDefaultApi.put(`/api/Billing/UpdateDataForDataLine/${billingId}`, line);
};

type QueryFnType = typeof editDataLineBilling;

type UseEditDataLineBillingOptions = {
  data: IPostEditDataLineBilling | {};
  dataLineID: number;
  billingId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditDataLineBilling = ({ config, dataLineID }: UseEditDataLineBillingOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Ελέγχου.`, 500);
            console.error('Couldnt edit new billing', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries([`getAllBillingsViaDataLineID_${dataLineID}`])
            addNotification(`Ο Έλεγχος ενημερώθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: editDataLineBilling,
    })
}